import React, { PureComponent, Fragment } from 'react';
import { Checkbox, Label, Popup } from 'semantic-ui-react'
import CustomUpdateRenderer from './custom_update_renderer'
import { getText, markItemAsReviewed, stopEventPropagation } from '../helpers';

export default class RiskCard extends PureComponent {
  constructor(props){
    super(props)

    this.state = {}
    this.initializeState(props)
  
  }

  componentWillReceiveProps(nextProps){
    this.updateClassName(nextProps)
    this.initializeState(nextProps)
  }

  initializeState = (props) => {
    const { state } = this;
    state.editing = false
    state.switchVisibilityPending = false;

    const { workPhase, activity, hazard, unwantedEvent, languageName, permission, className } = props
    const can_update = permission && permission.can_update;
    const work_phase_english = workPhase && workPhase.translations["English"] && workPhase.translations["English"].trim();
    const activity_english = activity && activity.translations["English"] && activity.translations["English"].trim();
    const hazard_english = hazard && hazard.translations["English"] && hazard.translations["English"].trim();
    const unwanted_event_english = unwantedEvent && unwantedEvent.translations["English"] && unwantedEvent.translations["English"].trim();

    state.workPhase = work_phase_english;
    state.activity = activity_english;
    state.hazard = hazard_english;
    state.unwantedEvent = unwanted_event_english;

    if (workPhase && activity && hazard && unwantedEvent){
      state.cardId = unwantedEvent.id
      state.value = unwantedEvent.translations[languageName]
      state.className = className
      state.isEditable = (["work_phase", "activity", "hazard", "unwanted_event"].includes(unwantedEvent.is_custom ) && can_update)
      state.columnName = "unwanted_event"
      state.searchTerm = `${work_phase_english} / ${activity_english} / ${hazard_english} / ${unwanted_event_english}`;
    } else if (workPhase && activity && hazard) {
      state.cardId = hazard.id
      state.value = hazard.translations[languageName]
      state.className = className
      state.isEditable = (["work_phase", "activity", "hazard"].includes(hazard.is_custom ) && can_update)
      state.columnName = "hazard"
      state.searchTerm = `${work_phase_english} / ${activity_english} / ${hazard_english}`;
    } else if (workPhase && activity) {
      state.cardId = activity.id
      state.value = activity.translations[languageName]
      state.className = className
      state.isEditable = (["work_phase", "activity"].includes(activity.is_custom) && can_update)
      state.columnName = "activity"
      state.searchTerm = `${work_phase_english} / ${activity_english}`;
    } else if (workPhase) {
      state.cardId = workPhase.id
      state.value = workPhase.translations[languageName]
      state.className = className
      state.isEditable = (workPhase.metadata.is_custom === "work_phase" && can_update)
      state.columnName = "work_phase_or_ambient_exposure"
      state.searchTerm = work_phase_english;
    }

    this.setState(state)
  }

  updateClassName = (nextProps) => {
    if (this.props.languageName===nextProps.languageName) return

    let { className, editing } = this.state;
    className = nextProps.className;

    if (editing){ 
      className += ' editing'
    } else{
      className = className.replace(' editing', '')
    }
    this.setState({className})
  }

  onCheckboxToggle = (e, { value }) => {
    const { switchRisksVisibility, riskIds } = this.props;
    const { columnName: column_name, searchTerm: search_term, workPhase, activity, hazard, unwantedEvent } = this.state;
    const details = { hidden: (value==='true'), column_name, search_term, workPhase, activity, hazard, unwantedEvent, risk_ids: riskIds };

    switchRisksVisibility(details, this.setSwitchVisibilityPending);
  }

  setSwitchVisibilityPending = (value) => {
    this.setState({ switchVisibilityPending: value });
  }

  onSaveClick = (value, oldValue, updatedRisk) => {
    const { onSaveClick } = this.props;
    const { columnName } = this.state;

    onSaveClick(value, oldValue, columnName, updatedRisk);
    this.toggleEdit(false);
  }

  onDeleteClick = (searchTerm, deletedRisk) => {
    const { onDeleteClick } = this.props
    const { columnName } = this.state;

    onDeleteClick(searchTerm, columnName, deletedRisk);
    this.toggleEdit(false);
  }

  toggleEdit = (show) => {
    let { editing, className } = this.state
    editing = show
    if (show){ 
      className += ' editing'
    } else{
      className = className.replace(' editing', '')
    }
    this.setState({editing, className})
  }

  staticRenderer = () => {
    const { value, className } = this.state;
    const { pendingReview={}, cardType } = this.props;
    const { id: pendingReviewId, created_at: createdAt, template_flags: templateFlags={} } = pendingReview;
    const {
      is_work_phase_added: isWorkPhaseAdded=false,
      is_activity_added: isActivityAdded=false,
      is_hazard_added: isHazardAdded=false,
      is_unwanted_event_added: isUnwantedEventAdded=false 
    } = templateFlags;

    const isWorkPhaseCard = cardType === 'Work Phase';
    const isActivityCard = cardType === 'Activity';
    const isHazardCard = cardType === 'Hazard';
    const isUnwantedEventCard = cardType === 'Unwanted Event';

    return (
      <div className={ className }>
        {
          pendingReviewId
          ?
          <span className='card-content'>
            <span className='description'>{value}</span>
            { (isWorkPhaseAdded && isWorkPhaseCard) && <span className='note'>({getText('Work Phase added to template')} - {createdAt}.)</span>}
            { (isActivityAdded && isActivityCard) && <span className='note'>({getText('Activity added to template')} - {createdAt}.)</span>}
            { (isHazardAdded && isHazardCard) && <span className='note'>({getText('Hazard added to template')} - {createdAt}.)</span>}
            { (isUnwantedEventAdded && isUnwantedEventCard) && <span className='note'>({getText('Unwanted Event added to template')} - {createdAt}.)</span>}
            { isUnwantedEventCard && <a onClick={ () => this.onMarkAsReviewed(pendingReviewId) }>{getText('Mark as Reviewed')}</a>}
          </span>
          :
          <span className='card-content'>{value}</span>
        }
      </div>
    )
  }

  onMarkAsReviewed = (reviewId) => {
    markItemAsReviewed(reviewId, this.props.refreshPendingReviews);
  }

  render() {
    const { translations, risk, permission, onUpdatePending, onDeletePending, unselectedCount, totalUnselectedCount, selectLabel, unselectLabel, inScope, outOfScope } = this.props
    const { editing, value, isEditable, cardId, switchVisibilityPending } = this.state;
    return (
      <Fragment>
        {
          isEditable ?
            <CustomUpdateRenderer
              value={ value }
              risk={ risk }
              translations={translations}
              permission={permission}
              onUpdatePending={ onUpdatePending }
              onDeletePending={ onDeletePending }
              onSaveClick={ this.onSaveClick }
              onDeleteClick={ this.onDeleteClick }
              onEditClick={ () => this.toggleEdit(true) }
              onCancelClick={ () => this.toggleEdit(false) }
            />
          : this.staticRenderer()
        }
        {
          !(editing) && permission && permission.can_update &&
          <div className="cards-activity-indicator" onClick={stopEventPropagation}>
            <div className="checkbox-wrap">
              <Checkbox
                style={{margin: 0}}
                radio
                key={ cardId + "_false" }
                label={ selectLabel }
                value={ 'false' }
                name={ "work_phase_" +  cardId}
                onChange={ this.onCheckboxToggle }
                checked={ inScope }
              />
              <Checkbox
                style={{margin: 0}}
                radio
                key={ cardId + "_true" }
                label={ unselectLabel }
                value={ 'true' }
                name={ "work_phase_" +  cardId }
                onChange={ this.onCheckboxToggle }
                checked={ outOfScope }
              />
            </div>
            { 
              unselectedCount > 0 && 
              <div>
                <Popup
                  trigger={ <Label color="red" circular className="unselected">{ unselectedCount }</Label> }
                  content={ totalUnselectedCount }
                  className = "cards-activity-indicator-popup"
                  horizontalOffset={8}
                />
              </div>
            }
            {
              switchVisibilityPending &&
              <div className="synch-toggle-msg"><i className="loading circle notched icon" /></div>
            }
          </div>
        }
      </Fragment>

    )
  }
}



// WEBPACK FOOTER //
// ./src/components/risk_card.js